/**
 * @ngdoc service
 * @name lmApp.service:AssetService
 * @description
 * A service for manipulate assets on LH
 */

lmApp
  .service('AssetService', ['$rootScope', '$q', '$http', 'ValidatorService',
    function ($rootScope, $q, $http, ValidatorService) {

    var service = {};

    /**
     * @ngdoc method
     * @name CreateNewVod
     * @methodOf lmApp.AssetService
     * @description
     * Create new asset from data
     *
     * @param {Number} ext_id
     * @param {*} asset
     * @returns {Deferred.promise}
     */
    service.CreateNewVod = function (ext_id, asset) {
      var deferred = $q.defer();

      var language = $rootScope.locale;

      var data = {
        ext_id: ext_id,
        year: asset.year ? asset.year : 1900,
        duration: asset.duration || 0,
        metadata: {},
        definition: asset.definition || 'SD'
      };

      if (asset.country_id) data.country_id = asset.country_id;
      if (asset.studio) data.studio_id = asset.studio;

      data.metadata[language] = {
        'title': asset.title,
        'description': asset.description
      };

      data.metadata['_'] = {
        'title': asset.title,
        'description': asset.description
      };

      data.metadata = JSON.stringify(data.metadata);

      lh.common.request.post('asset/mgmt/movie/create', data)
        .then(function (response) {
          deferred.resolve(response);
        }, function (reason) {
          reason.url = 'asset/mgmt/movie/create';
          reason.data = data;
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    /**
     * @ngdoc method
     * @name CreateNewTVSeries
     * @methodOf lmApp.AssetService
     * @description
     * Create new TV SERIES
     *
     * @param ext_id
     * @param asset
     * @returns {Deferred.promise}
     */
    service.CreateNewTVSeries = function (ext_id, asset) {
      var deferred = $q.defer();

      var language = $rootScope.locale;
      var data = {
        ext_id: ext_id,
        year: asset.year ? asset.year : 1900,
        metadata: {}
      };

      if (asset.country_id) data.country_id = asset.country_id;
      if (asset.studio) data.studio_id = asset.studio;

      data.metadata[language] = {
        'title': asset.title,
        'description': asset.description
      };

      data.metadata['_'] = {
        'title': asset.title,
        'description': asset.description
      };

      data.metadata = JSON.stringify(data.metadata);

      lh.common.request.post('asset/mgmt/tv_series/create', data)
        .then(function (response) {
          deferred.resolve(response);
        }, function (reason) {
          reason.url = 'asset/mgmt/tv_series/create';
          reason.data = data;
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    /**
     * @ngdoc method
     * @name CreateNewTVSeason
     * @methodOf lmApp.AssetService
     * @description
     * Create new TV Season
     *
     * @param ext_id
     * @param asset
     * @param tv_series
     * @returns {Deferred.promise}
     */
    service.CreateNewTVSeason = function (ext_id, asset, tv_series) {
      var deferred = $q.defer();

      var language = $rootScope.locale;
      var data = {
        ext_id: ext_id,
        tv_series_id: tv_series.id,
        index: tv_series.season_index,
        metadata: {}
      };

      data.metadata[language] = {
        'title': asset.title
      };

      data.metadata['_'] = {
        'title': asset.title
      };

      data.metadata = JSON.stringify(data.metadata);

      lh.common.request.post('asset/mgmt/tv_series/season/create', data)
        .then(function (response) {
          deferred.resolve(response);
        }, function (reason) {
          reason.url = 'asset/mgmt/tv_series/season/create';
          reason.data = data;
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    /**
     * @ngdoc method
     * @name CreateNewTVEpisode
     * @methodOf lmApp.AssetService
     * @description
     * Create new TV Episode
     *
     * @param ext_id
     * @param asset
     * @param tv_series
     * @returns {Deferred.promise}
     */
    service.CreateNewTVEpisode = function (ext_id, asset, tv_series) {
      var deferred = $q.defer();

      var language = $rootScope.locale;
      var data = {
        tv_series_id: tv_series.id,
        ext_id: ext_id,
        season_id: tv_series.season_id,
        index: tv_series.episode_index || 0,
        metadata: {},
        duration: asset.duration || 0
      };

      data.metadata[language] = {
        'title': asset.title,
        'description': asset.description
      };

      data.metadata['_'] = {
        'title': asset.title,
        'description': asset.description
      };

      data.metadata = JSON.stringify(data.metadata);

      lh.common.request.post('asset/mgmt/tv_series/episode/create', data)
        .then(function (response) {
          deferred.resolve(response);
        }, function (reason) {
          reason.url = 'asset/mgmt/tv_series/episode/create';
          reason.data = data;
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    /**
     * @ngdoc method
     * @name CreateNewLive
     * @methodOf lmApp.AssetService
     * @description
     * Create new LIVE
     *
     * @param ext_id
     * @param {{er_lcn: String}} metadata
     * @returns {Deferred.promise}
     */
    service.CreateNewLive = function (ext_id, metadata) {
      var deferred = $q.defer();

      var language = $rootScope.locale;
      var data = {
        ext_id: ext_id,
        is_epg_available: +metadata.is_epg_available,
        metadata: {}
      };

      if (metadata.is_epg_available) {
        if (metadata.epg_channel_id) data.epg_channel_id = metadata.epg_channel_id;
      }

      if (metadata.lcn) {
        data.lcn = metadata.lcn;
      } else if (metadata.er_lcn) {
        data.lcn = metadata.er_lcn;
      } else {
        data.lcn = 0;
      }

      data.metadata[language] = {
        'title': metadata.title,
        'description': metadata.description
      };

      data.metadata['_'] = {
        'title': metadata.title,
        'description': metadata.description
      };

      data.metadata = JSON.stringify(data.metadata);

      lh.common.request.post('asset/mgmt/live/create', data)
        .then(function (response) {
          deferred.resolve(response);
        }, function (reason) {
          reason.url = 'asset/mgmt/live/create';
          reason.data = data;
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    /**
     * @ngdoc method
     * @name CreateNewLive
     * @methodOf lmApp.AssetService
     * @description
     * Create new LIVE
     *
     * @param ext_id
     * @param {{er_lcn: String}} metadata
     * @returns {Deferred.promise}
     */
    service.CreateNewVirtualLive = function (ext_id, metadata) {
      var deferred = $q.defer();

      var language = $rootScope.locale;
      var data = {
        ext_id: ext_id,
        metadata: {}
      };

      if (metadata.lcn) {
        data.lcn = metadata.lcn;
      } else if (metadata.er_lcn) {
        data.lcn = metadata.er_lcn;
      } else {
        data.lcn = 0;
      }

      data.metadata[language] = {
        'title': metadata.title,
        'description': metadata.description
      };

      data.metadata['_'] = {
        'title': metadata.title,
        'description': metadata.description
      };

      data.type = 'playlist';

      data.metadata = JSON.stringify(data.metadata);

      lh.common.request.post('asset/mgmt/live/create', data)
        .then(function (response) {
          deferred.resolve(response);
        }, function (reason) {
          reason.url = 'asset/mgmt/live/create';
          reason.data = data;
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    /**
     * @ngdoc method
     * @name DeleteAsset
     * @methodOf lmApp.AssetService
     * @description
     * Create new asset from data
     *
     * @param {*} asset
     * @returns {Deferred.promise}
     */
    service.DeleteAsset = function (asset) {
      var deferred = $q.defer();

      var url = 'asset/mgmt/remove';
      var data = {
        asset_id: asset.id
      };

      lh.common.request.post(url, data)
        .then(function (response) {
          deferred.resolve(response);
        }, function (reason) {
          reason.url = url;
          reason.data = data;
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    /**
     * @ngdoc method
     * @name UpdateCommonAssetMetadata
     * @methodOf lmApp.AssetService
     * @description
     * Update common asset metadata
     *
     * @param data
     * @returns {Deferred.promise}
     */
    service.UpdateCommonAssetMetadata = function (data) {
      var deferred = $q.defer();

      lh.common.request.post('asset/mgmt/update', data)
        .then(function (response) {
          deferred.resolve(response);
        }, function (reason) {
          reason.url = 'asset/mgmt/update';
          reason.data = data;
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    /**
     * @ngdoc method
     * @name UpdateCommonAssetMetadata
     * @methodOf lmApp.AssetService
     * @description
     * Update Vod Metadata
     *
     * @param asset
     * @returns {Deferred.promise}
     *
     */
    service.UpdateVodMetadata = function (asset) {
      var deferred = $q.defer();

      var language = $rootScope.locale;
      var data = {
        asset_id: asset.id,
        year: asset.year ? asset.year : 1900,
        duration: asset.duration || 0,
        metadata: {},
        definition: asset.definition || 'SD'
      };

      if (asset.country_id) data.country_id = asset.country_id;
      if (asset.studio) data.studio_id = asset.studio;

      data.metadata['_'] = {
        'title': asset.title,
        'description': asset.description
      };

      data.metadata[language] = {
        'title': asset.title,
        'description': asset.description
      };

      data.metadata = JSON.stringify(data.metadata);

      lh.common.request.post('asset/mgmt/movie/update', data)
        .then(function (response) {
          deferred.resolve(response);
        }, function (reason) {
          reason.url = 'asset/mgmt/movie/update';
          reason.data = data;
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    /**
     * @ngdoc method
     * @name UpdateTVSeriesMetadata
     * @methodOf lmApp.AssetService
     * @description
     * Update TV SERIES Metadata
     *
     * @param asset
     * @returns {Deferred.promise}
     *
     */
    service.UpdateTVSeriesMetadata = function (asset) {
      var deferred = $q.defer();

      var language = $rootScope.locale;
      var data = {
        tv_series_id: asset.id,
        year: asset.year ? asset.year : 1900,
        metadata: {}
      };

      if (asset.country_id) data.country_id = asset.country_id;
      if (asset.studio) data.studio_id = asset.studio;

      data.metadata['_'] = {
        'title': asset.title,
        'description': asset.description
      };

      data.metadata[language] = {
        'title': asset.title,
        'description': asset.description
      };

      data.metadata = JSON.stringify(data.metadata);

      lh.common.request.post('asset/mgmt/tv_series/update', data)
        .then(function (response) {
          deferred.resolve(response);
        }, function (reason) {
          reason.url = 'asset/mgmt/tv_series/update';
          reason.data = data;
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    /**
     * @ngdoc method
     * @name UpdateTVSeriesMetadata
     * @methodOf lmApp.AssetService
     * @description
     * Update TV Season Metadata
     *
     * @param asset
     * @param tv_series
     * @returns {Deferred.promise}
     *
     */
    service.UpdateTVSeasonMetadata = function (asset, tv_series) {
      var deferred = $q.defer();

      var language = $rootScope.locale;
      var data = {
        season_id: tv_series.season_id,
        tv_series_id: tv_series.id,
        index: tv_series.season_index || 0,
        metadata: {}
      };

      data.metadata['_'] = {
        'title': asset.title
      };

      data.metadata[language] = {
        'title': asset.title
      };

      data.metadata = JSON.stringify(data.metadata);

      lh.common.request.post('asset/mgmt/tv_series/season/update', data)
        .then(function (response) {
          deferred.resolve(response);
        }, function (reason) {
          reason.url = 'asset/mgmt/tv_series/season/update';
          reason.data = data;
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    /**
     * @ngdoc method
     * @name UpdateTVSeriesMetadata
     * @methodOf lmApp.AssetService
     * @description
     * Update TV Episode Metadata
     *
     * @param asset
     * @param tv_series
     * @returns {Deferred.promise}
     *
     */
    service.UpdateTVEpisodeMetadata = function (asset, tv_series) {
      var deferred = $q.defer();

      var language = $rootScope.locale;
      var data = {
        asset_id: asset.id,
        duration: asset.duration || 0,
        index: tv_series.episode_index || 0,
        season_id: tv_series.season_id,
        metadata: {}
      };

      data.metadata['_'] = {
        'title': asset.title,
        'description': asset.description
      };

      data.metadata[language] = {
        'title': asset.title,
        'description': asset.description
      };

      data.metadata = JSON.stringify(data.metadata);

      lh.common.request.post('asset/mgmt/tv_series/episode/update', data)
        .then(function (response) {
          deferred.resolve(response);
        }, function (reason) {
          reason.url = 'asset/mgmt/tv_series/episode/update';
          reason.data = data;
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    /**
     * @ngdoc method
     * @name UpdateTVSeriesMetadata
     * @methodOf lmApp.AssetService
     * @description
     * Update Live Metadata
     *
     * @param asset
     * @returns {Deferred.promise}
     *
     */
    service.UpdateLiveMetadata = function (asset) {
      var deferred = $q.defer();

      var language = $rootScope.locale;
      var data = {
        asset_id: asset.id,
        is_epg_available: +asset.is_epg_available,
        metadata: {},
        definition: asset.definition || 'SD'
      };

      if (asset.is_epg_available) {
        if (asset.epg_channel_id) data.epg_channel_id = asset.epg_channel_id;
      } else {
        data.epg_channel_id = 0;
      }

      if (asset.lcn) {
        data.lcn = asset.lcn;
      } else if (asset.er_lcn) {
        data.lcn = asset.er_lcn;
      } else {
        data.lcn = 0;
      }

      data.metadata['_'] = {
        'title': asset.title,
        'description': asset.description
      };

      data.metadata[language] = {
        'title': asset.title,
        'description': asset.description
      };

      data.metadata = JSON.stringify(data.metadata);

      lh.common.request.post('asset/mgmt/live/update', data)
        .then(function (response) {
          deferred.resolve(response);
        }, function (reason) {
          reason.url = 'asset/mgmt/live/update';
          reason.data = data;
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    /**
     * @ngdoc method
     * @name UpdateTVSeriesMetadata
     * @methodOf lmApp.AssetService
     * @description
     * Update Live Metadata
     *
     * @param asset
     * @returns {Deferred.promise}
     *
     */
    service.UpdateVirtualLiveMetadata = function (asset) {
      var deferred = $q.defer();

      var language = $rootScope.locale;
      var data = {
        asset_id: asset.id,
        metadata: {}
      };

      if (asset.lcn) {
        data.lcn = asset.lcn;
      } else if (asset.er_lcn) {
        data.lcn = asset.er_lcn;
      } else {
        data.lcn = 0;
      }

      data.metadata['_'] = {
        'title': asset.title,
        'description': asset.description
      };

      data.metadata[language] = {
        'title': asset.title,
        'description': asset.description
      };

      data.metadata = JSON.stringify(data.metadata);

      data.type = 'playlist';

      lh.common.request.post('asset/mgmt/live/update', data)
        .then(function (response) {
          deferred.resolve(response);
        }, function (reason) {
          reason.url = 'asset/mgmt/live/update';
          reason.data = data;
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    /**
     * @ngdoc function
     * @name SetAdult
     * @description
     * Process adult flag
     *
     * @param asset_id
     * @param value
     * @returns {*}
     */
    service.SetAdult = function (asset_id, value) {
      var deferred = $q.defer();

      var data = {
        asset_id: asset_id,
        has_adult_content: +!!value
      };

      lh.common.request.post('asset/mgmt/update', data)
        .then(function (response) {
          deferred.resolve(response);
        }, function (reason) {
          reason.url = 'asset/mgmt/update';
          reason.data = data;
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    /**
     * Set tags to asset
     * @param tags
     * @param asset_id
     * @returns {*}
     */
    service.tagsSet = function (tags, asset_id) {
      var deferred = $q.defer();

      var data = {
        asset_id: asset_id,
        tags: tags.join(',')
      };

      lh.common.request.post('/asset/mgmt/tag/set', data)
        .then(function (response) {
          deferred.resolve(response);
        }, function (reason) {
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    /**
     * @ngdoc function
     * @name processGenres
     * @description
     * Process genres with assoc or deassoc
     *
     * @param genres
     * @param asset_id
     * @param url
     * @returns {*}
     */
    function processGenres(genres, asset_id, url) {
      var deferred = $q.defer();

      var idList = [];
      genres.map(function (genre) {
        idList.push(genre.id);
      });

      var data = {
        asset_id: asset_id,
        genre_id: idList.join(',')
      };

      lh.common.request.post(url, data)
        .then(function (response) {
          deferred.resolve(response);
        }, function (reason) {
          deferred.reject(reason);
        });

      return deferred.promise;
    }

    /**
     * @ngdoc method
     * @name AddGenres
     * @methodOf lmApp.AssetService
     * @description
     * Add genres list to asset
     *
     * @param genres
     * @param asset_id
     * @returns {*}
     */
    service.AddGenres = function (genres, asset_id) {
      return processGenres(genres, asset_id, 'asset/mgmt/genre/assoc');
    };

    service.RemoveGenres = function (genres, asset_id) {
      return processGenres(genres, asset_id, 'asset/mgmt/genre/deassoc');
    };

    function processPlatforms(platforms, asset_id, url) {
      var deferred = $q.defer();
      var idList = [];
      platforms.map(function (platform) {
        idList.push(platform.extid);
      });

      var data = {
        asset_id: asset_id,
        platform_extid: idList.join(',')
      };

      lh.common.request.post(url, data)
        .then(function (response) {
          deferred.resolve(response);
        }, function (reason) {
          deferred.reject(reason);
        });

      return deferred.promise;
    }

    service.AddPlatforms = function (platforms, asset_id) {
      return processPlatforms(platforms, asset_id, 'asset/mgmt/platform/assoc');
    };

    service.RemovePlatforms = function (platforms, asset_id) {
      return processPlatforms(platforms, asset_id, 'asset/mgmt/platform/deassoc');
    };

    function processCategories(categories, asset_id, url) {
      var deferred = $q.defer();
      var idList = [];
      categories.map(function (category) {
        idList.push(category.id);
      });

      var data = {
        asset_id: asset_id,
        category_id: idList.join(',')
      };

      lh.common.request.post(url, data)
        .then(function (response) {
          deferred.resolve(response);
        }, function (reason) {
          deferred.reject(reason);
        });

      return deferred.promise;
    }

    service.AddCategory = function (categories, asset_id) {
      return processCategories(categories, asset_id, 'asset/mgmt/category/assoc');
    };

    service.RemoveCategory = function (categories, asset_id) {
      return processCategories(categories, asset_id, 'asset/mgmt/category/deassoc');
    };

    service.CreatePerson = function (person) {
      var deferred = $q.defer();

      var data = {
        role: person.role,
        metadata: {}
      };

      var metadata = {
        first_name: person.first_name,
        middle_name: person.middle_name,
        second_name: person.second_name
      };

      if ($rootScope.locale) data.metadata[$rootScope.locale] = metadata;

      data.metadata['_'] = metadata;

      data.metadata = JSON.stringify(data.metadata);

      lh.common.request.post('metadata/mgmt/person/create', data)
        .then(function (response) {
          deferred.resolve(response);
        }, function (reason) {
          reason.url = 'metadata/mgmt/person/create';
          reason.data = data;
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    function processPersons(persons, asset_id, url) {
      var deferred = $q.defer();
      var idList = [];
      persons.map(function (person) {
        idList.push(person.id);
      });

      var data = {
        asset_id: asset_id,
        person_id: idList.join(',')
      };

      lh.common.request.post(url, data)
        .then(function (response) {
          deferred.resolve(response);
        }, function (reason) {
          deferred.reject(reason);
        });

      return deferred.promise;
    }

    service.AddPerson = function (persons, asset_id) {
      return processPersons(persons, asset_id, 'asset/mgmt/person/assoc');
    };

    service.RemovePerson = function (persons, asset_id) {
      return processPersons(persons, asset_id, 'asset/mgmt/person/deassoc');
    };

    service.UpdateRentalRotation = function (asset, asset_id) {
      var deferred = $q.defer();

      var data = {
        asset_id: asset_id,
        rotation_start: asset.rotation_start.unix(),
        rotation_finish: asset.rotation_finish.unix()
      };

      if (asset.license_start) data.license_start = asset.license_start.unix();
      if (asset.license_finish) data.license_finish = asset.license_finish.unix();

      lh.common.request.post('asset/mgmt/update', data)
        .then(function (response) {
          deferred.resolve(response);
        }, function (reason) {
          reason.url = 'asset/mgmt/update';
          reason.data = data;
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    service.GetPoster = function (asset) {
      var deferred = $q.defer();

      lh.models.vodAsset.methods.getPosterUrl(asset)
        .then(function (url) {
          deferred.resolve(url);
        }, function (reason) {
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    service.UploadImageToCloud = function (image, progress) {
      var deferred = $q.defer();
      if (progress) {
        var progressBar = progress.find('.determinate');
        progress.css({display: 'block'});
      }

      var params = {
        Key: Date.now() + '_' + image.name,
        ContentType: image.type,
        ContentLength: image.size,
        Body: image,
        ACL: 'public-read'
      };

      $rootScope.aws
        .upload(params, function (err, data) {
          if (err) {
            err.url = 'AWS3 CloudServer';
            err.data = image;
            deferred.reject(err);
            return;
          }

          if (progress) progress.css({display: 'none'});
          deferred.resolve(data);
        })
        .on('httpUploadProgress', function (progress) {
            if (progress && progressBar) progressBar.css({width: Math.round(progress.loaded / progress.total * 100)});
          }
        );

      return deferred.promise;
    };

    service.UpdateVodPoster = function (asset_id, poster_url, resource_id) {
      var deferred = $q.defer();

      var data = {
        asset_id: asset_id,
        resource_id: resource_id,
        url: poster_url
      };

      lh.common.request.post('asset/mgmt/picture/update', data)
        .then(function (response) {
          deferred.resolve(response);
        }, function (reason) {
          reason.url = 'asset/mgmt/picture/update';
          reason.data = data;
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    service.AddVodPoster = function (poster_url, asset_id) {
      var deferred = $q.defer();

      var data = {
        asset_id: asset_id,
        url: poster_url,
        category: 'poster_blueprint'
      };

      lh.common.request.post('asset/mgmt/picture/create', data)
        .then(function (url) {
          deferred.resolve(url);
        }, function (reason) {
          reason.url = 'asset/mgmt/picture/create';
          reason.data = data;
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    service.GetStream = function (asset, type, category) {
      var deferred = $q.defer();

      lh.models.viewAsset.methods.getMediaUrl(asset, category, {stream_type: type})
        .then(function (url) {
          deferred.resolve(url);
        }, function (reason) {
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    service.ProcessVodStreams = function (streams, asset_id, category) {

      var deferred = $q.defer();

      var streamsQ = {};
      _.forIn(streams, function (stream, type) {
        if (type === 'youtube') {
          var channelId = '';
          var channelType = '';
          if (stream.youtube) {
            channelId = stream.youtube.id;
            channelType = stream.youtube.type;
          } else {

            var channelParse = stream.source.split('/');
            for (var i = 0; i < channelParse.length; i++) {
              if (channelParse[i] === 'user') {
                channelId = channelParse[i + 1];
                channelType = 'user';
                break;
              }

              if (channelParse[i] === 'channel') {
                channelId = channelParse[i + 1];
                channelType = 'channel';
                break;
              }

              if (channelParse[i].indexOf('watch?v=') !== -1) {
                channelId = stream.source.match(ValidatorService.youtubeVideoRegExp)[1];
                channelType = 'video';
                break;
              }
            }
          }

          if (channelId) {
            stream.source = 'youtube+' + channelType + '://' + channelId;
          } else {
            stream.source = '';
          }
        }

        if (!stream.streamOld && !stream.doneWithError && stream.source && !stream.toDelete) {

          streamsQ[type] = service.AddVodStream(stream, asset_id, type, category, stream.deploymentStrategy);
        } else if (stream.toDelete) {

          streamsQ[type] = service.RemoveVodStream(stream, asset_id);
        }
      });

      $q.all(streamsQ)
        .then(function (response) {
          deferred.resolve(response);
        })
        .catch(function (errors) {
          deferred.reject(errors);
        });

      return deferred.promise;
    };

    service.AddVodStream = function (stream, asset_id, type, category) {
      var deferred = $q.defer();

      if (!stream.type) {
        return;
      }

      var data = {
        asset_id: asset_id,
        url: stream.source,
        source_type: stream.type.indexOf('raw') !== -1 ? 'raw' : 'stream'
      };

      if (type === 'shoutcast') {
        data.stream_type = 'shoutcast';
      }

      if (stream.type !== 'youtube_stream') {
        data.deployment_strategy = stream.deploymentStrategy || 'origin';
        if (data.deployment_strategy === 'origin' && stream.overrideDeliveryMethod) data.override_delivery_method = 'cdn';
      }

      if (stream.file) data.override_original_source = stream.file.name;
      if (category) data.category = category;

      lh.common.request.post('asset/mgmt/stream/create', data)
        .then(function (response) {
          deferred.resolve(response);
        }, function (reason) {
          reason.url = 'asset/mgmt/stream/create';
          reason.data = data;
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    service.RemoveVodStream = function (stream, asset_id, type) {
      var deferred = $q.defer();

      var data = {
        asset_id: asset_id,
        resource_id: stream.streamResourceId
      };

      lh.common.request.post('asset/mgmt/stream/remove', data)
        .then(function (response) {
          deferred.resolve(response);
        }, function (reason) {
          reason.url = 'asset/mgmt/stream/remove';
          reason.data = data;
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    service.UpdateVodStream = function (stream, asset_id) {
      var deferred = $q.defer();

      var data = {
        asset_id: asset_id,
        url: stream.streamNew,
        resource_id: stream.streamResourceId
      };

      lh.common.request.post('asset/mgmt/stream/update', data)
        .then(function (response) {
          deferred.resolve(response);
        }, function (reason) {
          reason.url = 'asset/mgmt/stream/update';
          reason.data = data;
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    service.GetAssetById = function (id) {
      var deferred = $q.defer();

      var url = 'collection/vod.asset/query/dimension/id/eq/' + id;

      lh.common.request(url)
        .then(function (response) {
          deferred.resolve(response.collection);
        }, function (reason) {
          reason.url = url;
          reason.data = 'GET';
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    service.GetAssetByExtId = function (extId) {
      var deferred = $q.defer();

      var url = 'collection/vod.asset/query/dimension/extid/in/' + extId;

      lh.common.request(url)
        .then(function (response) {
          deferred.resolve(response.collection);
        }, function (reason) {
          reason.url = url;
          reason.data = 'GET';
          deferred.reject(reason);
        });

      return deferred.promise;
    };


    service.GetAssetInId = function (ids) {
      var deferred = $q.defer();

      var url = 'collection/vod.asset/query/dimension/id/in/' + ids.join(',');

      lh.common.request(url)
        .then(function (response) {
          deferred.resolve(response.collection);
        }, function (reason) {
          reason.url = url;
          reason.data = 'GET';
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    service.GetAssetsByGroup = function (ids) {
      var deferred = $q.defer();

      var url = 'collection/vod.asset/query/dimension/group_id/in/' + ids.join(',');

      lh.common.request(url)
        .then(function (response) {
          deferred.resolve(response.collection);
        }, function (reason) {
          reason.url = url;
          reason.data = 'GET';
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    service.GetReportData = function () {
      var deferred = $q.defer();

      var countsQ = {};

      var data = {
        select: 'id,title,description'
      };


      countsQ.vod = (function () {
        var deferred = $q.defer();

        lh.common.request.get('collection/vod.asset/query/dimension/view/eq/vod', data)
          .then(function (response) {
            deferred.resolve(response.collection.length);
          }, function (reason) {
            reason.url = 'collection/vod.asset/query/dimension/view/eq/vod';
            reason.data = 'GET';
            deferred.reject(reason);
          });

        return deferred.promise;
      })();

      countsQ.live = (function () {
        var deferred = $q.defer();

        lh.common.request.get('collection/vod.asset/query/dimension/view/eq/live', data)
          .then(function (response) {
            deferred.resolve(response.collection.length);
          }, function (reason) {
            reason.url = 'collection/vod.asset/query/dimension/view/eq/live';
            reason.data = 'GET';
            deferred.reject(reason);
          });

        return deferred.promise;
      })();

      $q.all(countsQ)
        .then(function (response) {
          deferred.resolve(response);
        })
        .catch(function (errors) {
          deferred.reject(errors);
        });

      return deferred.promise;
    };

    service.GetAllAvailableVod = function (offset, limit, sort) {
      var deferred = $q.defer();

      var data = {
        offset: offset,
        limit: limit
      };

      //TODO: Use LH SDK API
      var url = 'collection/vod.asset/query/dimension/view/eq/vod' +
        '/enum/' + data.offset + ',' + data.limit;

      var reqParams = {};
      if (sort) {
        reqParams.sort = sort;
      }

      lh.common.request.get(url, reqParams).then(function (response) {
        deferred.resolve(response.collection);
      }, function (reason) {
        reason.url = url;
        reason.data = "GET";
        deferred.reject(reason);
      });

      return deferred.promise;
    };

    service.GetAllAvailableMovies = function (offset, limit) {
      var deferred = $q.defer();

      var data = {
        offset: offset,
        limit: limit
      };

      //TODO: Use LH SDK API
      var url = 'collection/vod.asset/query/dimension/type/eq/movie/dimension/is_episode/eq/0' +
        '/enum/' + data.offset + ',' + data.limit;

      lh.common.request(url).then(function (response) {
        deferred.resolve(response.collection);
      }, function (reason) {
        reason.url = url;
        reason.data = "GET";
        deferred.reject(reason);
      });

      return deferred.promise;
    };

    service.GetAllAvailableSeries = function (offset, limit) {
      var deferred = $q.defer();

      var data = {
        offset: offset,
        limit: limit
      };

      //TODO: Use LH SDK API
      var url = 'collection/vod.asset/query/dimension/type/eq/package/dimension/package_type/eq/tv_series' +
        '/enum/' + data.offset + ',' + data.limit;

      lh.common.request(url).then(function (response) {
        deferred.resolve(response.collection);
      }, function (reason) {
        reason.url = url;
        reason.data = "GET";
        deferred.reject(reason);
      });

      return deferred.promise;
    };

    service.GetAllAvailableChannels = function (offset, limit) {
      var deferred = $q.defer();

      var data = {
        offset: offset,
        limit: limit
      };

      //TODO: Use LH SDK API
      var url = 'collection/vod.asset/query/dimension/view/eq/live' +
        '/enum/' + data.offset + ',' + data.limit;

      lh.common.request(url).then(function (response) {
        deferred.resolve(response.collection);
      }, function (reason) {
        reason.url = url;
        reason.data = "GET";
        deferred.reject(reason);
      });

      return deferred.promise;
    };

    service.GetAllAvailableCatchupChannels = function (offset, limit) {
      var deferred = $q.defer();

      //TODO: Use LH SDK API
      var url = 'collection/vod.asset/query/dimension/view/eq/live/dimension/is_catchup_available/eq/1';

      lh.common.request(url).then(function (response) {
        deferred.resolve(response.collection);
      }, function (reason) {
        reason.url = url;
        reason.data = "GET";
        deferred.reject(reason);
      });

      return deferred.promise;
    };

    service.SearchByKeyword = function (text, opt_params, limit, offset) {
      var deferred = $q.defer();

      var data = {
        offset: limit || 0,
        limit: offset || 20
      };

      var url = 'collection/vod.asset/query';

      if (text) url += '/dimension/title/match/' + text;

      if (opt_params) {
        if (opt_params.genres && opt_params.genres.length) url += '/dimension/genre_id/in/' + opt_params.genres.join(',');
        if (opt_params.categories && opt_params.categories.length) url += '/dimension/category_id/in/' + opt_params.categories.join(',');
        if (opt_params.view) {
          url += '/dimension/view/eq/' + opt_params.view;
        } else {
          url += '/dimension/is_episode/eq/0';
        }
        if (opt_params.filter && opt_params.filter.live) {
          url += '/dimension/type/neq/channel';
        }
        if (opt_params.filter && opt_params.filter.packages) {
          url += '/dimension/type/neq/package';
        }
        if (opt_params.onlyPackages === true) {
          url += '/dimension/package_type/eq/generic';
        }
        if (opt_params.groups && opt_params.groups.length) {
          url += '/dimension/group_id/in/' + opt_params.groups.join(',');
        }
      }

      url += '/enum/' + data.offset + ',' + data.limit;

      var reqParams = {};
      if (opt_params.sort) {
        reqParams.sort = opt_params.sort;
      }

      lh.common.request.get(url, reqParams)
        .then(function (response) {
          deferred.resolve(response.collection);
        }, function (reason) {
          reason.url = url;
          reason.data = opt_params;
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    service.Search = function (text, opt_params, limit, offset) {
        var deferred = $q.defer();

        var url = 'asset/search/query';
        var reqParams = {
          offset: limit || 0,
          limit: offset || 20
        };
        if (opt_params.sort) {
          reqParams.sort = opt_params.sort;
        }

        if (text) {
          reqParams.text = text;
        }
        if (opt_params.genres && opt_params.genres.length) {
          reqParams.genre_id = opt_params.genres.join(',');
        }
        if (opt_params.categories && opt_params.categories.length) {
          reqParams.category_id = opt_params.categories.join(',');
        }
        if (opt_params.view && opt_params.view === 'live') {
          reqParams.type = 'channel';
        }

        lh.common.request.get(url, reqParams)
            .then(function (response) {
              deferred.resolve(response.collection);
            }, function (reason) {
              reason.url = url;
              reason.data = opt_params;
              deferred.reject(reason);
            });

        return deferred.promise;
    };

    service.GetGenresCollection = function () {
      var deferred = $q.defer();

      lh.common.request('collection/vod.genre/query' + '?t=' + Date.now())
        .then(function (response) {
          deferred.resolve(response.collection.filter(function (genre) {
            return genre.namespace !== 'epg';
          }));
        }, function (reason) {
          reason.url = 'collection/vod.genre/query' + '?t=' + Date.now();
          reason.data = 'GET';
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    service.GetProvidersCollection = function () {
      var deferred = $q.defer();
      lh.common.request('collection/vod.provider/query' + '?t=' + Date.now())
        .then(function (response) {
          deferred.resolve(response.collection.filter(function (genre) {
            return genre.namespace !== 'epg';
          }));
        }, function (reason) {
          reason.url = 'collection/vod.provider/query' + '?t=' + Date.now();
          reason.data = 'GET';
          deferred.reject(reason);
        });
      return deferred.promise;
    };

    service.GetCountriesCollection = function () {
      var deferred = $q.defer();

      lh.common.request('collection/vod.country/query/dimension/namespace/neq/epg' + '?t=' + Date.now())
        .then(function (response) {
          deferred.resolve(response.collection);
        }, function (reason) {
          reason.url = 'collection/vod.country/query/dimension/namespace/neq/epg';
          reason.data = 'GET';
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    service.GetCategoryCollection = function (opt_options) {
      var deferred = $q.defer();
      var url;

      if (!opt_options) {

        url = 'collection/vod.category/query' + '?t=' + Date.now();

      } else {
        if (opt_options.ids) {
          url = 'collection/vod.category/query/dimension/id/in/' + opt_options.ids.join(',');
        }
        if (opt_options.extids) {
          url = 'collection/vod.category/query/dimension/extid/in/' + opt_options.extids.join(',') + '?t=' + Date.now();
        }
      }

      lh.common.request(url)
        .then(function (response) {
          deferred.resolve(response.collection);
        }, function (reason) {
          reason.url = url;
          reason.data = 'GET';
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    service.GetEpgIDCollection = function () {
      var deferred = $q.defer();

      lh.common.request('collection/epg.channel/query' + '?t=' + Date.now())
        .then(function (response) {
          deferred.resolve(response.collection);
        }, function (reason) {
          reason.url = 'collection/epg.channel/query' + '?t=' + Date.now();
          reason.data = 'GET';
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    service.GetStudiosCollection = function () {
      var deferred = $q.defer();

      lh.common.request('collection/vod.studio/query/dimension/namespace/neq/epg' + '?t=' + Date.now())
        .then(function (response) {
          deferred.resolve(response.collection);
        }, function (reason) {
          reason.url = 'collection/vod.studio/query/dimension/namespace/neq/epg' + '?t=' + Date.now();
          reason.data = 'GET';
          deferred.reject(reason);
        });

      return deferred.promise;
    };


    service.GetPlatforms = function (extid) {
      var deferred = $q.defer();

      var url = 'collection/platform/query';

      if (extid) {
        url += '/dimension/extid/eq/' + extid;
      }

      lh.common.request(url)
        .then(function (response) {
          deferred.resolve(response.collection);
        }, function (reason) {
          reason.url = url;
          reason.data = 'GET';
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    service.CatchupDisable = function (asset) {
      var deferred = $q.defer();

      var data = {
        asset_id: asset.id
      };

      lh.common.request.post('asset/mgmt/catchup/disable', data)
        .then(function (response) {
          deferred.resolve(response);
        }, function (reason) {
          reason.url = 'asset/mgmt/catchup/disable';
          reason.data = data;
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    service.CatchupEnable = function (asset, catchup_source, catchup_depth) {
      var deferred = $q.defer();

      var data = {
        asset_id: asset.id,
        stream_url: catchup_source,
        depth: catchup_depth
      };

      lh.common.request.post('asset/mgmt/catchup/enable', data)
        .then(function (response) {
          deferred.resolve(response);
        }, function (reason) {
          reason.url = 'asset/mgmt/catchup/enable';
          reason.data = data;
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    service.NpvrDisable = function (asset) {
      var deferred = $q.defer();

      var data = {
        asset_id: asset.id
      };

      lh.common.request.post('asset/mgmt/npvr/disable', data)
        .then(function (response) {
          deferred.resolve(response);
        }, function (reason) {
          reason.url = 'asset/mgmt/npvr/disable';
          reason.data = data;
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    service.NpvrEnable = function (asset, npvr_source) {
      var deferred = $q.defer();

      var data = {
        asset_id: asset.id,
        stream_url: npvr_source
      };

      lh.common.request.post('asset/mgmt/npvr/enable', data)
        .then(function (response) {
          deferred.resolve(response);
        }, function (reason) {
          reason.url = 'asset/mgmt/npvr/enable';
          reason.data = data;
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    service.SearchPerson = function (text, role) {
      var deferred = $q.defer();

      var url = 'collection/vod.person/query/dimension/name/match/' + text;

      if (role) url += '/dimension/role/eq/' + role;

      url += '?t=' + Date.now();

      lh.common.request(url)
        .then(function (response) {
          deferred.resolve(response.collection);
        }, function (reason) {
          reason.url = url;
          reason.data = 'GET';
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    service.GetIMDBCollection = function (title, type, season, episode) {
      var deferred = $q.defer();

      var url = '';
      if (type === 'episode' && season && episode) {
        url = '/imdb/find/tvseries?title=' + title + '&season=' + season + '&episode=' + episode;
      } else {
        url = '/imdb/find/movie?title=' + title;

        if (type) url += '&type=' + type;
      }

      $http.get(url)
        .then(function (res) {
          var response = res.data;

          if (type === 'episode') {
            if (response.Response === 'False') {
              deferred.resolve([]);
            } else {
              deferred.resolve([response]);
            }
          } else {
            if (response.Response === 'False') {
              deferred.resolve([]);
            } else {
              deferred.resolve(response.Search);
            }
          }
        }, function (res) {
          var reason = res.data;
          deferred.reject(reason);
        });

      return deferred.promise;
    };


    service.GetIMDBItem = function (imdbId) {
      var deferred = $q.defer();

      var url = '/imdb/find/id/' + imdbId;

      $http.get(url)
        .then(function (res) {
          var response = res.data;
          deferred.resolve(response);
        }, function (res) {
          var reason = res.data;
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    service.GetIMDBPoster = function (imdbId) {
      var deferred = $q.defer();

      var url = '/imdb/find/poster/' + imdbId;

      $http.get(url)
        .then(function (res) {
          var response = res.data;
          deferred.resolve(response);
        }, function (res) {
          var reason = res.data;
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    service.AddRating = function (ratings, asset_id) {
      var deferred = $q.defer();

      var errors = [];

      var requestQ = ratings.map(function (rating) {
        var data = {
          asset_id: asset_id,
          type: rating.type,
          value: rating.value
        };

        if (rating.votes_count) data.votes_count = rating.votes_count;

        lh.common.request.post('asset/mgmt/rating/assoc', data)
          .then(function (response) {
            deferred.resolve(response);
          }, function (reason) {
            reason.url = 'asset/mgmt/rating/assoc';
            reason.data = data;
            deferred.reject(reason);
          });
      });

      $q.all(requestQ)
        .then(function () {
          deferred.resolve();
        })
        .catch(function (errors) {
          deferred.reject(errors);
        });

      return deferred.promise;
    };

    service.RemoveRating = function (ratings, asset_id) {
      var deferred = $q.defer();

      var errors = [];

      var requestQ = ratings.map(function (rating) {
        var data = {
          asset_id: asset_id,
          type: rating.type
        };

        lh.common.request.post('asset/mgmt/rating/deassoc', data)
          .then(function (response) {
            deferred.resolve(response);
          }, function (reason) {
            reason.url = 'asset/mgmt/rating/deassoc';
            reason.data = data;
            deferred.reject(reason);
          });
      });

      $q.all(requestQ)
        .then(function () {
          deferred.resolve();
        })
        .catch(function (errors) {
          deferred.reject(errors);
        });

      return deferred.promise;
    };

    service.UpdateRating = function (rating) {
      var deferred = $q.defer();

      var data = {
        type: rating.type,
        value: rating.avg_value,
        votes_count: rating.votes_count,
        rating_id: rating.id
      };

      lh.common.request.post('metadata/mgmt/rating/update', data)
        .then(function (response) {
          deferred.resolve(response);
        }, function (reason) {
          reason.url = 'metadata/mgmt/rating/update';
          reason.data = data;
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    service.getChannelByLcn = function (lcn) {
      if (!lcn) return $q.when([]);

      var deferred = $q.defer();

      //TODO: Use LH SDK API
      var url = 'collection/vod.asset/query/dimension/view/eq/live' +
        '/dimension/er_lcn/eq/' + lcn;

      lh.common.request(url).then(function (response) {
        deferred.resolve(response.collection);
      }, function (reason) {
        reason.url = url;
        reason.data = "GET";
        deferred.reject(reason);
      });

      return deferred.promise;
    };

    return service;
  }
  ])
;
